import Phaser from 'phaser';

import './css/style.css';

import RoundRectanglePlugin from 'phaser3-rex-plugins/plugins/roundrectangle-plugin.js';
import TagTextPlugin from 'phaser3-rex-plugins/plugins/tagtext-plugin.js';
import SliderPlugin from 'phaser3-rex-plugins/plugins/slider-plugin.js';

import Boot from './js/scenes/Boot.js';
import Preloader from './js/scenes/Preloader.js';
import Intro from './js/scenes/Intro.js';
import IntroVideo from './js/scenes/IntroVideo.js';
import Activite1 from './js/scenes/Activite1.js';
import Activite1Video from './js/scenes/Activite1Video.js';
import Activite2 from './js/scenes/Activite2.js';
import Activite2Video from './js/scenes/Activite2Video.js';
import Activite3 from './js/scenes/Activite3.js';
import Activite3Video from './js/scenes/Activite3Video.js';
import Activite4 from './js/scenes/Activite4.js';
import Activite4Video from './js/scenes/Activite4Video.js';
import End from './js/scenes/End.js';
import EndVideo from './js/scenes/EndVideo.js';
import Karaoke from './js/scenes/Karaoke.js';
import KaraokeEnd from './js/scenes/KaraokeEnd.js';


//Création du jeu
var game;

window.onload = function () {
    var isMobile = /Mobi|Android/i.test(navigator.userAgent) || Phaser.Input.Touch.enabled;
    var config = {
        autoResize: true,
        width: 1920,
        height: 1080,
        backgroundColor: '#FFFFFF',
        type: Phaser.AUTO,
        parent: "game",
        scale: {
            mode: isMobile ? Phaser.Scale.FIT : Phaser.Scale.FIT,
            autoCenter: Phaser.Scale.CENTER_BOTH
        },
        dom: {
            createContainer: true
        },
        plugins: {
            global: [{
                key: 'rexRoundRectanglePlugin',
                plugin: RoundRectanglePlugin,
                start: true
            },
            {
                key: 'rexTagTextPlugin',
                plugin: TagTextPlugin,
                start: true
            },{
                key: 'rexSlider',
                plugin: SliderPlugin,
                start: true
            }]
        },
        fps:{
            target: 30,
            forceSetTimeOut: true
        },
        scene: [Boot, Preloader, Intro, IntroVideo, Activite1, Activite1Video, Activite2, Activite2Video, Activite3, Activite3Video, Activite4, Activite4Video, End, EndVideo,Karaoke, KaraokeEnd]
    };

    game = new Phaser.Game(config);

    console.log('  __       __|  __  ');
    console.log('__)  (__| (__| (__) ');
    console.log('        |           ');

    game.scene.start("Boot");
}
